import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from "@angular/core";
import { UIState } from "@dtm-frontend/shared/ui";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Store } from "@ngxs/store";
import { KpoFilesComponent } from "../files/kpo-files.component";
import { BROCHURE_FILE } from "../kpo.data";

const COMPETITION_EMAIL = "konkursCK@pansa.pl";

@UntilDestroy()
@Component({
    selector: "dtm-main-page-lib-kpo-competition",
    templateUrl: "./competition.component.html",
    styleUrls: ["../../shared.scss", "./competition.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompetitionComponent {
    @ViewChild(KpoFilesComponent, { read: ElementRef }) protected filesComponent: ElementRef<HTMLHtmlElement> | undefined;

    protected readonly COMPETITION_EMAIL = COMPETITION_EMAIL;
    protected readonly BROCHURE_FILE = BROCHURE_FILE;

    protected readonly activeLanguage$ = this.store.select(UIState.activeLanguage);

    constructor(private readonly store: Store) {}

    public async scrollToFiles() {
        this.filesComponent?.nativeElement.scrollIntoView();
    }
}
